import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Busy busy busy",
  "description": "",
  "published": "2007-04-17T00:00:00.000Z",
  "redirect_from": ["/blog/busy-busy-busy/swizec/231"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`I've been working on a final paper for computer science class quite fevereshly since Sunday. The behemoth is due in a few days and I guess that's the reason why I'm working a bit more furiously than if there weere weeks to spare ... or at all for that matter. As it stands right now the thing is 20 pages long and about to grow a few more before it's done. Then come the inevitable rereads and style and grammar changes, a standard in any type of writing really.`}</p>
    <p>{`As you may or may not have noticed the comic hasn't been updated ever since January and I do realise that's quite inexcusable, hell it's been almost three months now. And I `}<em parentName="p">{`am`}</em>{` sorry, really I am. The sad truth behind this innocent blunder is the overwhelming amount of school work there is to be done in order to have good enough grades in the final year of high school so I can do my A-levels and finally close this bloody chapter in my life. Plus I have a job I go to every day after school so that doesn't help much with leaving me free time to work on the comic. I'll try my best to have it completed by the end of the month.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      